#import "../fragments/account-summary-fragment.graphql"

query GetAccountSummary($id: ID!) {
    account(id: $id) {
        ...AccountSummaryFragment
    }
}
